/** @format */

import * as actionTypes from "./../types";
import { apiError } from "../../utils/GTMDataLayer";
// import { logger } from "cbt-sdk";
import { logger } from "@goldenbird1/ui-logger-library";
import base64 from "base-64";
import Router from "next/router";
import { v4 as uuidv4 } from "uuid";
import {

  message,

} from "antd";

let retryInventoryCount = 0;

export const getCart =
  (token, currency = "USD", buyerId, callback = "") =>
  async (dispatch) => {
        let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/order-orchestration/v1/my/cart?currency=${currency}`;
    return await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "*/*",
        "trace-id": uuidv4()
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getCart",
            res.statusText || "Error from getCart api.",
            "GET",
            "checkout"
          );
          throw res;
        }
      })
      .then((res) => {
        let result = { ...res };
        result["currency"] = "USD";
        if (callback) {
          callback(result);
        }
        return dispatch(setCart(result));
      })
      .catch((err) => {
        logger(
          "error",
          "Error from getCart api: " +
            url +
            " :buyerId => " +
            buyerId +
            ": error => " +
            err.statusText,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
        apiError("getCart", err.statusText, "GET", "checkout");
        console.log(err);
        if (err.status === 401) {
          Router.push("/signin");
        }
        if (callback) {
          callback(err);
        }
      });
  };

export const setCart = (data) => {
  return {
    type: actionTypes.SET_CART,
    payload: {
      cart: data,
    },
  };
};

export const getSavedForLater =
  (token, currency, buyerId, callback = false) =>
  async (dispatch) => {
       let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/wish-list/v1/my/wish-list?currency=${currency}`;
    return await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "*/*",
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getSavedForLater",
            res.statusText || "Error while fetching save for later.",
            "GET",
            "checkout"
          );
          throw res;
        }
      })
      .then((res) => {
        if (callback) {
          callback(res);
        }
        return dispatch(setSFL(res));
      })
      .catch((err) => {
        logger(
          "error",
          "Error from getSavedForLater api: " +
            url +
            " : buyerId => " +
            buyerId +
            ": error => " +
            err.statusText,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
        apiError("getSavedForLater", err.statusText, "GET", "checkout");
        if (err.status === 401) {
          Router.push("/signin");
        }
        // console.log(err.message);
        // message.error((err.message || err), 5);
        // setErrors(errors.concat(err));
      });
  };

export const setSFL = (data) => {
  return {
    type: actionTypes.SET_SFL,
    payload: {
      sfl: data,
    },
  };
};

export const getShippingData =
  (app_token, currency, shippingTerm, couponCode = 0, couponDiscount = 0, buyerId, callback = "") =>
  async (dispatch) => {
    let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/order-orchestration/v1/shipping?currency=${currency}&shippingTerms=${shippingTerm}&promoCode=${couponCode}&promoDiscount=${couponDiscount}`;
    return await fetch(url, {
      method: "PUT",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + app_token,
        'trace-id':uuidv4()
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then((res) => {
        if (callback) {
          callback(res);
        }
      })
      .catch((err) => {
        logger(
          "error",
          "Error from getShippingData api: " +
            url +
            " : buyerId => " +
            buyerId +
            ": error => " +
            err.statusText,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
        console.log("Error while fetching shipping page data", err.statusText);
        if (err.status === 401) {
          Router.push("/signin");
        }
        if (err.status === 400) {
          message.error("Total cart value must be greater than zero");
        }
        if (callback) {
          callback({ error: "Error from getShippingData api:" + err });
        }
      });
  };

export const getOrderId =
  (token, callback = "") =>
  async (dispatch) => {
    let url = process.env.NEXT_PUBLIC_REACT_APP_ORDER_URL + "/v1/my/orderId";

    return await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "*/*",
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.text().then(function (text) {
            return text ? { orderId: text } : { orderId: "" };
          });
        } else {
          apiError(
            "checkCart",
            res.statusText || "Error while getting orderId details.",
            "GET",
            "checkout"
          );
          throw res;
        }
      })
      .then((res) => {
        if (callback) {
          callback(res);
        }
      })
      .catch((err) => {
        logger("error", "Error from getOrderId api: " + url + " : " +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError("checkCart", err.statusText, "GET", "checkout");
        console.log(err);
        if(err.status === 401){
          Router.push('/signin');
        }
      });
  };

export const checkCart =
  (token, buyerId, callback = "") =>
  async (dispatch) => {
    let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/orders/v1/my";
    return await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "*/*",
        'trace-id': uuidv4()
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.text().then(function (text) {
            return text ? JSON.parse(text) : {};
          });
        } else {
          apiError(
            "checkCart",
            res.statusText || "Error while saving user deatils.",
            "GET",
            "checkout"
          );
          throw res;
        }
      })
      .then((res) => {
        if (callback) {
          callback(res);
        }
        return dispatch(setCart(res));
      })
      .catch((err) => {
        logger("error", "Error from checkCart api: " + url + " : buyerId => " +buyerId+ ': error => ' +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError("checkCart", err.statusText, "GET", "checkout");
        console.log(err);
        if(err.status === 401){
          Router.push('/signin');
        }
      });
  };

export const checkInventory =
  (token, skuId = "", buyerId, callback = "") =>
  async (dispatch) => {
    let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/inventory/v1`;
    if(token && typeof token === 'string'){
      return await fetch(url, {
        method: "POST",
        body: JSON.stringify(skuId),
        headers: {
          "Content-Type": "application/json",
          Authorization: token
            ? `Bearer ${token}`
            : "Bearer " + process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN,
          "trace-id": uuidv4(),
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            apiError(
              "checkInventory",
              res.statusText || "Oops something went wrong. Please try again!",
              "POST",
              "checkout"
            );
            throw res;
          }
        })
        .then((res) => {
          callback(res);
        })
        .catch((err) => {
          logger(
            "error",
            "Error from checkInventory api: " +
              skuId +
              ": buyerId => " +
              buyerId +
              ": error => " +
              err.statusText,
            process.env.NEXT_PUBLIC_LOGGER_URL
          );
          apiError("checkInventory", err.statusText, "POST", "checkout");
          if (err.status === 401) {
            Router.push("/signin");
          } else {
            if (retryInventoryCount < 3) {
              checkInventory(token, skuId, buyerId, callback);
            } else {
              console.log(err);
            }
            retryInventoryCount++;
          }
        });
    } else {
      Router.push('/signin');
    }
  };

export const updateCart =
  (token, action = "", obj = "", buyerId, callback = "") =>
  async (dispatch) => {
 
    let url =
      process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
      `/orders/v1/my/cart?cart_action=${action}`;
    return await fetch(url, {
      method: "PUT",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          callback();
        } else {
          apiError(
            "updateCart",
            res.statusText || "Error from updateCart api.",
            "PUT",
            "checkout"
          );
          throw res;
        }
      })
      .catch((err) => {
        logger(
          "error",
          "Error from updateCart api " +
            action +
            " :" +
            url +
            ",payload=" +
            JSON.stringify(obj) +
            " : error => " +
            err.status +
            ": buyerId => " +
            buyerId,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
        apiError("updateCart", err.status, "PUT", "checkout");
        console.log(err);
        if (err.status === 401) {
          Router.push("/signin");
        }
      });
  };

export const getOrder =
  (orderId, token, buyerId, callback = false) =>
  async (dispatch) => {
    let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/order-orchestration/v1/orders/composite/${orderId}`;
    return await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "*/*",
        'trace-id':uuidv4()
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getOrder",
            res.statusText || "Error while saving user deatils.",
            "GET",
            "checkout"
          );
          throw res;
        }
      })
      .then((res) => {
        let result = { ...res };
        result["currency"] = "USD";
        if (callback) {
          callback(result);
        }
        return dispatch(setCart(result));
      })
      .catch((err) => {
        logger("error", "Error from getOrder/orders composite api: " + url +': buyerId => '+buyerId+ ": error =>" +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError("getOrder", err.statusText, "GET", "checkout");
        console.log(err);
        if(err.status === 401){
          Router.push('/signin');
        }
      });
  };

export const checkCartAPI =
  (token, buyerId, callback = "") =>
  async (dispatch) => {
    let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/orders/v1/my";
    return await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "*/*",
        'trace-id': uuidv4()
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "checkCartAPI",
            res.statusText || "Error while saving user deatils.",
            "GET",
            "checkout"
          );
          throw res;
        }
      })
      .then((res) => {
        if (callback) {
          callback(res);
        }
      })
      .catch((err) => {
        logger("error", "Error from checkCartAPI/orders api: " + url + ": buyerId =>  "+buyerId+ ': error => ' +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError("checkCartAPI", err.statusText, "GET", "checkout");
        console.log(err);
        if(err.status === 401){
          Router.push('/signin');
        }
      });
  };

export const getCoupon =
  (appToken, priceQuoteRef, buyerId, callback = "") =>
  async (dispatch) => {
    let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/home/v1/quotes/custom/${priceQuoteRef}`;
    fetch(
      url,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + appToken,
           'trace-id':uuidv4(),
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (callback) {
          callback(data.cartApplicablePromotions);
        }
      })
      .catch((err) => {
        logger("error", "Error from getCoupon api: " + url + ": buyerId => "+buyerId+ ': error => ' +err, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError("getCoupon", err, "GET", "checkout");
        console.log(err);
        if(err.status === 401){
          Router.push('/signin');
        }
        if (callback) {
          callback({ error: "There is an error" });
        }
      });
  };

export const getDataFromSameTheme = (token, themeGroup, buyerId, callback = "") => async (dispatch) => {
   let url =
     process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
     `/search/v1/seller-product-search?bird=lion&from=0&size=30&sort_order=DESC&sort_by=popularity&&f_themeGroup=${themeGroup}`;
 
  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      Accept: "*/*",
      'trace-id' : uuidv4()
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        apiError('getDataFromSameThemeAPI', res.statusText || "Error while getDataFromSameTheme.", 'GET', 'PDP');
        throw res;
      }
    })
    .then((res) => {
      if (callback) {
        callback(res);
      }
    })
    .catch((err) => {
      logger("error", "Error from getDataFromSameTheme api: " + url + ": error => " +err.statusText+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
      apiError('getDataFromSameThemeAPI', err.statusText, 'GET', 'PDP');
      console.log(err);
      if(err.status === 401){
        Router.push('/signin');
      }
    });
};

export const getDataFromSimilar = (token, articleId, l3Name,count = 12, buyerId, callback = "") => async (dispatch) => {
  let url = `${process.env.NEXT_PUBLIC_REACT_APP_RECOMMENDATION_ENGINE}/recommendation_engine/v2/get_recommendation`
  // let data = {
  //   "appSource" : "QALARA_WEB",
  //   "entityIds" : {
  //     "productId" : "PRODUCT::"+articleId
  //   },
  //   "numberOfRecommendations" : 20
  // };
  let data = {
    "articleId": [articleId],
    "l3Name": [l3Name]
  };
  return await fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    // headers: {
    //   "Content-Type": 'application/json',
    //   // "Authorization": "Basic " + base64.encode(uname + ":" + password)
    //   Authorization: "Bearer " + token,
    // },
    headers: {
      Authorization:"Bearer " + token,
      "x-client-id": process.env.NEXT_PUBLIC_REACT_APP_KEYCLOAK_CLIENT_ID,
      "Content-Type":"application/json",
  },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        apiError('getDataFromSimilar', res.statusText || "Error while getDataFromSimilar.", 'GET', 'PDP');
        throw res;
      }
    })
    .then((res) => {
      if (callback) {
        callback(res);
      }
    })
    .catch((err) => {
      logger("error", "Error from getDataFromSimilar api: " + url + ": error => " +err.statusText+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
      apiError('getDataFromSimilar', err.statusText, 'GET', 'PDP');
      console.log(err);
      // if(err.status === 401){
      //   Router.push('/signin');
      // }
    });
};


// export const getDataFromSimilar = (articleId, count = 12, buyerId, callback = "") => async (dispatch) => {
//   const uname = "argoid";
//   const password = "CJhAd1Mm07";
//   let url = process.env.NEXT_PUBLIC_QALARA_SIMILAR_BASE_URL + `/qalara/v2/recommendations/PDP-SIMILAR-PRODUCTS`;
//   let data = {
//     "appSource" : "QALARA_WEB",
//     "entityIds" : {
//       "productId" : "PRODUCT::"+articleId
//     },
//     "numberOfRecommendations" : 20
//   };
//   return await fetch(url, {
//     method: "POST",
//     body: JSON.stringify(data),
//     headers: {
//       "Content-Type": 'application/json',
//       "Authorization": "Basic " + base64.encode(uname + ":" + password)
//     },
//   })
//     .then((res) => {
//       if (res.ok) {
//         return res.json();
//       } else {
//         apiError('getDataFromSimilar', res.statusText || "Error while getDataFromSimilar.", 'GET', 'PDP');
//         throw res;
//       }
//     })
//     .then((res) => {
//       if (callback) {
//         callback(res);
//       }
//     })
//     .catch((err) => {
//       logger("error", "Error from getDataFromSimilar api: " + url + ": error => " +err.statusText+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
//       apiError('getDataFromSimilar', err.statusText, 'GET', 'PDP');
//       console.log(err);
//       if(err.status === 401){
//         Router.push('/signin');
//       }
//     });
// };
